const SELECTORS = {
    form: '.block-contact-form__content',
    formInner: '.js-contact-form',
    success: '.js-contact-success',
};
const initContactFormSuccess = () => {
    document.addEventListener('wpcf7mailsent', (event) => {
        const target = event.target;
        if (!target)
            return;
        const formWrapper = target.closest(SELECTORS.form);
        if (!formWrapper)
            return;
        const form = formWrapper.querySelector(SELECTORS.formInner);
        const success = formWrapper.querySelector(SELECTORS.success);
        if (form) {
            form.hidden = true;
        }
        if (success) {
            success.hidden = false;
        }
    });
};
document.addEventListener('DOMContentLoaded', initContactFormSuccess);
if (window.acf) {
    window.acf.addAction?.('render_block_preview', initContactFormSuccess);
}
export default initContactFormSuccess;
